import viLocale from "element-ui/lib/locale/lang/vi";

export default {
  ...viLocale,

  energyExchange: "Trao đổi tài nguyên",
  Aboutus: "giới thiệu nền tảng",
  FAQ: "câu hỏi thường gặp",
  Support: "Dịch vụ CSKH Online",
  Switchlanguage: "Chuyển đổi ngôn ngữ",
  tips1: "Mua số lần chuyển khoản",
  tips2: "Đơn giản, tiện lợi, giúp bạn tiết kiệm chi phí.",
  tips3: "Lưu ý: Do giá trị tiền mã hóa tăng mạnh, nguồn cung năng lượng đang khan hiếm, vui lòng kiểm tra số dư khi mua hàng!",
  tips4: "Hướng dẫn trao đổi năng lượng",
  tips5: "Vui lòng sử dụng ví phi tập trung để thuê năng lượng",
  tips6:
    "Hệ thống sẽ tính tổng lượng năng lượng cần đổi và số tiền thanh toán dựa trên nhu cầu thuê năng lượng. Chỉ hỗ trợ thanh toán bằng TRX.",
  tips7: "Sau khi hoàn tất chuyển khoản, nền tảng sẽ chuyển năng lượng tương ứng vào tài khoản thụ hưởng của bạn.",
  tips8: "Khuyến khích thuê theo nhu cầu và thuê lại khi hết năng lượng! Không giới hạn số lần thuê mỗi ngày!",
  tips9: "Giới thiệu về nền tảng TRON Energy",
  Economic: "kinh tế",

  SAFE: "an toàn",
  EFFICIENT: "hiệu suất cao",

  tips10:
    "Nền tảng TRON Energy là nền tảng trao đổi năng lượng trong hệ sinh thái TRON. Chúng tôi hướng đến mục tiêu giúp các nhà giao dịch trên TRON giảm thiểu chi phí năng lượng TRX cần thiết. Quá trình trao đổi đơn giản, nhanh chóng, giá cả hợp lý và cung cấp dịch vụ đổi năng lượng an toàn, hiệu quả 24/7.",

  tips11: "Giải quyết vấn đề phí giao dịch TRX quá cao",

  tips12: "Nhanh chóng và tiện lợi, chỉ cần chuyển khoản là có thể đổi năng lượng.",
  tips13: "Hỗ trợ USDT, chuyển khoản hợp đồng và triển khai hợp đồng.",
  tips14: "Giải pháp tiết kiệm chi phí dành cho người dùng Blockchain TRON.",
  tips15: "Câu Hỏi Thường Gặp FAQ",
  tips16: "Cách mua năng lượng ",
  tips17:
    "Hãy nhấp vào mục 'Đổi tài nguyên' ở đầu trang và điền thông tin mua, sau đó chuyển số TRX tương ứng vào tài khoản của nền tảng theo hướng dẫn.",
  tips18: "Khi nào năng lượng sẽ được gửi sau khi thanh toán thành công?",
  tips19:
    "Thông thường, năng lượng sẽ được chuyển đến trong vòng 6 giây sau khi thanh toán thành công. Tuy nhiên, do có thể xảy ra độ trễ trong quá trình truyền tải giao dịch, một số trường hợp hiếm gặp có thể bị trễ từ 30 đến 60 giây. Nếu bạn không nhận được năng lượng, vui lòng liên hệ với bộ phận CSKH để được hỗ trợ.",
  tips20: "Có thể đặt nhiều đơn hàng cùng lúc tại một địa chỉ nhận không?",
  tips21: "Có thể, một địa chỉ nhận có thể thực hiện nhiều đơn hàng mua mà không giới hạn số lần.",
  tips22: "Đơn hàng có thể hủy không?",

  tips23: "Khi bạn đã thanh toán vào tài khoản của nền tảng, đơn hàng không thể hủy.",
  Paymentaddress: "địa chỉ thanh toán",
  Receivingaddress: "Địa chỉ nhận",
  Keywords: "Địa chỉ thanh toán / Địa chỉ nhận / Mã hash giao dịch",
  Rentingenergy: "Thuê năng lượng",
  RentingBandwidth: "Thuê băng thông",
  resourceType: "Loại tài nguyên",
  Price: "Giá",
  pleaseSelect: "Vui lòng chọn",
  Createorder: "Tạo đơn hàng",
  cancel: "Huỷ bỏ",
  OnlineService: "CSKH online",
  tips24: "Nếu gặp bất kỳ vấn đề nào, vui lòng liên hệ với bộ phận CSKH Online.",
  tips25: "Nhấn để sao chép",
  pleaseInput: "Vui lòng nhập",
  tips26: "Vui lòng nhập số hợp lệ lớn hơn 0",
  tips27: "Tạo đơn hàng thất bại, vui lòng thử lại sau",
  day: "Ngày",
  minute: "Phút",
  hour: "Giờ",
  unitprice: "Đơn giá",
  confirm: "Xác nhận",
  prompt: "Thông báo",
  replicatingSuccess: "Sao chép thành công",
  tips28: "Số dư khả dụng trong energy pool (bể năng lượng)",
  tips28Bandwidth: "Số dư khả dụng trong bandwidth pool (bể băng thông)",
  tips29: "Địa chỉ nhận tiền trên sàn",
  tips30: "Xem mã QR nhận thanh toán",
  QRcode: "Mã QR nhận thanh toán của nền tảng",
  save: "Lưu",
  tips31: "Lịch sử nhận năng lượng mới nhất",
  rechargeHistory: "Lịch sử nạp tiền",
  recharge: "Nạp tiền",
  confirmRecharge:'Xác nhận nạp tiền',

  rechargeBalance: "Số tiền nạp",
  Users: "Địa chỉ nhận",
  ExchangeType: "Loại quy đổi",
  Amount: "Số lượng nhận",
  OrderState: "Trạng thái đơn hàng",
  searchKey: "Vui lòng nhập từ khoá tìm kiếm",
  search: "Tra cứu",
  tips32: "Truy vấn lịch sử nhận thất bại, vui lòng thử lại sau!",
  500: "Hệ thống lỗi",
  400: "Tham số không hợp lệ",
  10001: "Tên đăng nhập hoặc mật khẩu sai",
  10002: "Vui lòng đăng nhập trước",
  20001: "Địa chỉ đã được thêm, vui lòng không thêm trùng lặp",
  20002: "Vui lòng ủy quyền thuê năng lượng trước",
  20003: "Không đủ tài nguyên, vui lòng thử lại sau",
  20004: "Địa chỉ không hợp lệ",
  20005: "Chủ tài khoản không tồn tại",
  20006: "Số của chủ sở hữu tài chính được đặt không chính xác",
  20007: "Đơn hàng không thể thao tác",
  20008: "Thanh toán đơn hàng không tồn tại",
  20009: "Ví của chủ tài khoản không đủ năng lượng/ băng thông",
  20010: "Tạo mã QR không thành công",
  20011: "Số dư không đủ",
  20012: "Không tìm thấy doanh nghiệp",
  20013: "Vui lòng nhập địa chỉ thanh toán",

  20014: "Khóa bí mật không hợp",
  20015: "Không thể đặt lại mật khẩu của quản trị viên",
  20016: "Không thể đặt lại trạng thái của quản trị viên",
  20018: "Số lượng địa chỉ đã đạt đến giới hạn tối đa",
  20019: "Không thể thêm địa chỉ trùng lặp",
  10017: "Vui lòng nhập mật khẩu từ 6 đến 16 ký tự bao gồm cả số và chữ cái",
  10018: "Địa chỉ thanh toán không khớp",
  10019: "Số tiền thanh toán không khớp",
  10020: "Thiếu ID thanh toán doanh nghiệp",
  10021: "Giao dịch bị trùng lặp",
  10024: "Số dư năng lượng không đủ, vui lòng thử lại sau",
  90001: "Xin lỗi, dịch vụ đang bảo trì, vui lòng thử lại sau",
  10022:'Tên người dùng đã tồn tại',

  tips: "Thông báo",
  Copyaddress: "Sao chép địa chỉ",
  tips33: "TRON Energy nền tảng dịch vụ tiện lợi và tiết kiệm",
  tips34: "65,000 năng lượng có thể chuyển được một giao dịch",
  tips34Bandwidth: "280 băng thông có thể chuyển được một giao dịch",
  tips35: "Vui lòng nhập số nguyên",
  tips36: "Năng lượng đang được phát, vui lòng đợi...",
  tips37:'Hai mật khẩu không khớp',
  tips38:'Đổi mật khảu thành công, vui lòng đăng nhập lại',

  referralCode: "Mã giới thiệu",
  EnterprisePayKey: "Khóa bí mật thanh toán doanh nghiệp",
  EnterprisePayId: "ID thanh toán doanh nghiệp",
  rent: "Thuê",
  only: "Chỉ cần",
  energy: "Năng lượng",
  bandwidth: "Băng thông",
  currentPriceEffective: "Giá hiện hành",
  timeRangeSetting: "Khung giờ",
  Transactioncount: "Số lần giao dịch",
  Completepayment: "Hoàn tất thanh toán",
  Enterpriseuser: "Người dùng doanh nghiệp",
  Ordinaryuser: "Người dùng thông thường",
  TxHash: "Giao dịch hash",
  PromitBalance: "Số dư hiện tại của bạn là",
  AccountBalance: "Số dư tài khoản",
  login:'Đăng nhập',
  userName:'Tên người dùng',
  password:'Mật khẩu',
  register:'Đăng ký ngay',
  signUp:'Đăng ký',
  confirmPassword:'Xác nhận mật khẩu',
  orderNo: 'Mã đơn hàng',
  createTime: 'Thời gian tạo',
  balanceRecharge: 'Nạp tiền vào số dư',
  logOut:'Đăng xuất',
  editPw:'Thay đổi mật khẩu',
  oldPw:'Mật khẩu cũ',
  newPw:'Mật khẩu mới',
  PersonalInformation:'Thông tin người dùng',
  ProxyTxId: "Đại lý txId",
  noEnterprisePrice: "Hiện không có giá doanh nghiệp, vui lòng liên hệ CSKH ",
  addressBook: 'Sổ địa chỉ',
  address: 'Địa chỉ',
  operations: 'Thao tác',
  delete: 'Xóa',
  add: 'Thêm',
  pleaseInputAddress: 'Vui lòng nhập địa chỉ',
  addSuccess: 'Thêm thành công',
  deleteSuccess: 'Xóa thành công',
  confirmDelete: 'Bạn có chắc chắn muốn xóa địa chỉ này không?',
  monitorAddress: 'Địa chỉ giám sát',
  monitorAddressBook: 'Sổ địa chỉ giám sát',
  setMonitorInterval: 'Đặt khoảng thời gian giám sát',
  monitorInterval: 'Khoảng thời gian giám sát',
  oneHour: '1 giờ',
  threeHours: '3 giờ',
  sixHours: '6 giờ',
  twelveHours: '12 giờ',
  twentyFourHours: '24 giờ',
  platformReceiveAddress: 'Địa chỉ nhận của nền tảng',
  noExclusiveAddress: 'Chưa cấu hình địa chỉ độc quyền',
  noExclusiveAddressTip: 'Bạn chưa kích hoạt chức năng địa chỉ nạp tiền độc quyền. Vui lòng liên hệ dịch vụ khách hàng hoặc sử dụng chức năng bên dưới để tạo đơn nạp tiền thông thường',
  hasExclusiveAddress: 'Đã cấu hình địa chỉ độc quyền',
  yourExclusiveAddress: 'Địa chỉ nạp tiền độc quyền của bạn là',
  exclusiveAddressTip: 'Bạn có thể chuyển TRX trực tiếp và đợi khoảng 10 giây để hoàn tất tự động cộng điểm',
  canStillUseGeneral: 'Bạn vẫn có thể sử dụng chức năng bên dưới để tạo đơn nạp tiền thông thường',
  generalRechargeNotice: 'Đơn nạp tiền thông thường yêu cầu địa chỉ thanh toán và số tiền nạp phải khớp. Nếu nhập sai, vui lòng liên hệ dịch vụ khách hàng để xác minh và cộng điểm thủ công',
  notice: 'Lưu ý',
  refresh: 'Làm mới',
  refreshSuccess: 'Làm mới thành công',
  refreshFailed: 'Làm mới thất bại',
  copy: 'Sao chép',
  energyThreshold: "Ngưỡng năng lượng",
  pleaseInputEnergyThreshold: "Vui lòng nhập ngưỡng năng lượng",
  energyThresholdMustBeNumber: "Ngưỡng năng lượng phải là một số",
  energyThresholdRange: "Ngưỡng năng lượng phải từ 0 đến 100.000.000",
  monitorThreshold: "Ngưỡng giám sát",
  pleaseInputMonitorThreshold: "Vui lòng nhập ngưỡng giám sát",
  monitorThresholdMustBeNumber: "Ngưỡng giám sát phải là số",
  monitorThresholdRange: "Ngưỡng giám sát từ 0 đến 100.000.000",
  pleaseInputBandwidthThreshold: "Vui lòng nhập ngưỡng băng thông",
  rentalAmount: "Số lượng thuê",
  pleaseInputRentalAmount: "Vui lòng nhập số lượng thuê",
  rentalAmountMustBeNumber: "Số lượng thuê phải là số",
  rentalAmountRange: "Số lượng thuê từ 100 đến 1000000000",
  pleaseInputBandwidthAmount: "Vui lòng nhập lượng thuê băng thông",
  pleaseInputEnergyAmount: "Vui lòng nhập lượng thuê năng lượng",
  monitorPriceTypeMismatch: "Giá đã chọn không khớp loại tài nguyên",
  balanceNotifyThreshold: "Ngưỡng thông báo số dư không đủ",
  balanceNotifyInterval: "Khoảng thời gian thông báo",
  seconds: "Giây",
  valueRangeError: "Giá trị phải trong khoảng từ 0 đến 10.000.000",
  saveSuccess: "Đã lưu thành công",
  saveFailed: "Lưu thất bại",
  never: "Không bao giờ",
  tenMinutes: "10 phút",
  thirtyMinutes: "30 phút",
  twelveHours: "12 giờ",
  oneDay: "1 ngày",
  sevenDays: "7 ngày",
  bandwidthMinTip: "Thuê băng thông không được dưới {amount}",
  bandwidthPresetMin: "5.000",
  bandwidthPreset20: "5.600(20 lượt)",
  bandwidthPreset40: "11.200(40 lượt)",
  bandwidthAmountTooSmall: "Số lượng băng thông không được dưới {amount}",
  bandwidthAmountStepTip: "Khuyến nghị nhập theo bội số 280 băng thông/lượt (20 lượt=5.600, 40 lượt=11.200)"
};



// WEBPACK FOOTER //
// ./src/i18n/vi.js